import { Stack, styled, Typography } from '@mui/material';

export const Reports = () => {
  return (
    <TabContentContainer>
      <Typography fontSize={24} fontWeight={700} color="#226AAA">
        Reports
      </Typography>

      <Typography color="#6B7280">Maintenance reports will be displayed here.</Typography>
    </TabContentContainer>
  );
};

const TabContentContainer = styled(Stack)(() => ({
  flex: 1,
  gap: 10,
  paddingTop: 40,
  paddingBottom: 40
}));
